<div class="content-header pt-4 pb-2">
    <div class="container-fluid">
        <div class="row align-items-center mb-3">
            <div class="col-sm-6 d-flex align-items-center">
                <h1 class="m-0 text-light mr-2 page-title">Enquiries</h1>
            </div>
        </div>
    </div>
</div>

<section class="content">
    <div class="container-fluid">
        <div class="enquiry-table-container">
            <table class="table table-hover table-borderless text-center align-middle">
                <thead>
                    <tr>
                        <th width="5%">Sr.No</th>
                        <th width="15%">Customer Name</th>
                        <th width="12%">Phone</th>
                        <th width="18%">Address</th>
                        <th width="15%">City</th>
                        <th width="10%">State</th>
                        <th width="10%">Pincode</th>
                        <th width="10%">Status</th>
                        <th width="10%">Actions</th>
                    </tr>
                </thead>
                <tbody>
                    <!-- Loading state -->
                    <tr *ngIf="isLoading">
                        <td colspan="8" class="text-muted py-4">Loading enquiries...</td>
                    </tr>

                    <!-- Empty state -->
                    <tr *ngIf="!isLoading && enquiries.length === 0">
                        <td colspan="8" class="text-muted py-4">No enquiries found.</td>
                    </tr>

                    <!-- Data rows -->
                    <tr *ngFor="let enq of enquiries; let i = index">
                        <td class="text-muted">{{ i + 1 }}</td>
                        <td class="font-weight-bold text-dark">{{ enq.customerName }}</td>
                        <td class="text-muted">{{ enq.phoneNumber }}</td>
                        <td class="text-muted small">{{ enq.doorNo }}{{ enq.street ? ', ' + enq.street : '' }}{{
                            enq.village ? ', ' + enq.village : '' }}</td>
                        <td class="text-muted">{{ enq.city }}</td>
                        <td class="text-muted">{{ enq.state }}</td>
                        <td class="text-muted">{{ enq.pincode }}</td>
                        <td>
                            <div class="custom-control custom-switch">
                                <input type="checkbox" class="custom-control-input"
                                    id="customSwitchEnq-{{enq.enquiryId}}" [checked]="enq.enquiryStatus === 'OPEN'"
                                    (change)="toggleEnquiryStatus(enq, $event)">
                                <label class="custom-control-label" for="customSwitchEnq-{{enq.enquiryId}}"></label>
                            </div>
                        </td>
                        <td class="action-icons">
                            <a href="javascript:void(0)" class="text-success mx-2" title="View Details"
                                (click)="openViewModal(enq)"><i class="fas fa-eye"></i></a>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</section>

<!-- View Enquiry Modal -->
<div class="custom-modal-backdrop" *ngIf="isViewModalOpen && viewEnquiry">
    <div class="custom-modal">
        <div class="custom-modal-header">
            <h5 class="m-0"><i class="fas fa-question-circle mr-2"></i>Enquiry Details</h5>
            <button class="close-btn" (click)="closeViewModal()">&times;</button>
        </div>
        <div class="custom-modal-body">
            <div class="row">
                <div class="col-md-6 mb-3">
                    <span class="view-label">Customer Name</span>
                    <p class="view-value">{{ viewEnquiry.customerName }}</p>
                </div>
                <div class="col-md-6 mb-3">
                    <span class="view-label">Phone Number</span>
                    <p class="view-value">{{ viewEnquiry.phoneNumber }}</p>
                </div>
            </div>
            <div class="row">
                <div class="col-md-4 mb-3">
                    <span class="view-label">Door No</span>
                    <p class="view-value">{{ viewEnquiry.doorNo || '—' }}</p>
                </div>
                <div class="col-md-4 mb-3">
                    <span class="view-label">Street</span>
                    <p class="view-value">{{ viewEnquiry.street || '—' }}</p>
                </div>
                <div class="col-md-4 mb-3">
                    <span class="view-label">Village</span>
                    <p class="view-value">{{ viewEnquiry.village || '—' }}</p>
                </div>
            </div>
            <div class="row">
                <div class="col-md-4 mb-3">
                    <span class="view-label">City</span>
                    <p class="view-value">{{ viewEnquiry.city || '—' }}</p>
                </div>
                <div class="col-md-4 mb-3">
                    <span class="view-label">State</span>
                    <p class="view-value">{{ viewEnquiry.state || '—' }}</p>
                </div>
                <div class="col-md-4 mb-3">
                    <span class="view-label">Pincode</span>
                    <p class="view-value">{{ viewEnquiry.pincode || '—' }}</p>
                </div>
            </div>
            <div class="row" *ngIf="viewEnquiry.message">
                <div class="col-md-12 mb-3">
                    <span class="view-label">Message</span>
                    <p class="view-value message-text">{{ viewEnquiry.message }}</p>
                </div>
            </div>
            <div class="custom-modal-footer mt-4 text-right">
                <button type="button" class="btn btn-secondary" (click)="closeViewModal()">Close</button>
            </div>
        </div>
    </div>
</div>